import { shallowRef } from "vue";

type ScrollSyncSource = "editor" | "preview";

interface ScrollSyncState {
  progress: number;
  source: ScrollSyncSource | null;
  suppression?: {
    target: ScrollSyncSource;
    expiresAt: number;
  };
}

const SUPPRESSION_WINDOW_MS = 150;

const createInitialState = (): ScrollSyncState => ({
  progress: 0,
  source: null,
  suppression: undefined,
});

export const scrollSyncStore = shallowRef<ScrollSyncState>(
  createInitialState()
);

const notify = (source: ScrollSyncSource, progress: number) => {
  const now = Date.now();
  const currentState = scrollSyncStore.value;

  if (
    currentState.suppression &&
    currentState.suppression.target === source &&
    currentState.suppression.expiresAt > now
  ) {
    return;
  }

  scrollSyncStore.value = {
    progress,
    source,
    suppression: {
      target: source === "editor" ? "preview" : "editor",
      expiresAt: now + SUPPRESSION_WINDOW_MS,
    },
  };
};

export const notifyScrollInEditor = (progress: number) => {
  notify("editor", progress);
};

export const notifyScrollInPreview = (progress: number) => {
  notify("preview", progress);
};

export const resetScrollSyncStore = () => {
  scrollSyncStore.value = createInitialState();
};
